<div *ngIf="currentUser$ | async as currentUser">
  <ng-container *ngIf="internalAdminService.isInternalAdmin(currentUser)">
    <button
      *ngIf="flag$ | async; else accountNameTmp"
      type="button"
      mat-button
      [matMenuTriggerFor]="accountMenu"
    >
      <ng-container *ngTemplateOutlet="accountNameTmp"></ng-container>
    </button>

    <ng-template #accountNameTmp>
      <mat-icon class="org-account-icon material-icons-outlined">
        home_work</mat-icon
      >
      <span class="org-account-name pl-1 pr-4 py-3">
        {{ account?.name || '-- Missing Account Name --' }}
      </span>
    </ng-template>
  </ng-container>

  <button
    class="account-dropdown-button px-4 py-3"
    type="button"
    mat-button
    [matMenuTriggerFor]="menu"
  >
    <mat-icon class="material-icons-outlined"> account_circle</mat-icon>
    <span class="px-1"
      >{{ currentUser?.first_name }} {{ currentUser?.last_name }}</span
    >
    <mat-icon class="dropdown-arrow">expand_more</mat-icon>
  </button>
</div>
<ng-template #deactivationModal>
  <h1 mat-dialog-title class="mb-3">Deactivation Date</h1>
  <div mat-dialog-content>
    <mat-form-field>
      <mat-label>Deactivation Date</mat-label>
      <input
        matInput
        required
        [min]="minDeactivationDate"
        [formControl]="deactivationDate"
        [matDatepicker]="expirationDatepicker"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="expirationDatepicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #expirationDatepicker> </mat-datepicker>
      <mat-error> Please select a valid date </mat-error>
    </mat-form-field>
  </div>
  <div mat-dialog-actions class="justify-content-end">
    <button mat-stroked-button type="button" mat-dialog-close class="mr-2">
      Cancel
    </button>
    <button
      mat-flat-button
      type="button"
      color="primary"
      mat-dialog-close
      (click)="updateDeactivationDate()"
      [disabled]="deactivationDate.invalid"
      cdkFocusInitial
    >
      Submit
    </button>
  </div>
</ng-template>

<mat-menu #accountMenu="matMenu">
  <button mat-menu-item (click)="openModal()">Deactivation Date</button>
</mat-menu>
<mat-menu #menu="matMenu" class="account-dropdown-menu-container">
  <div class="account-dropdown-menu">
    <div
      class="account-dropdown-user-details"
      [class.with-bottom-border]="hidePlatformSwitcherBorder$ | async"
    >
      <div class="account-dropdown-user-initials-circle">
        <span class="account-dropdown-user-initials"
          >{{ (currentUser$ | async)?.first_name?.[0] || '-'






          }}{{ (currentUser$ | async)?.last_name?.[0] || '-' }}</span
        >
      </div>
      <div class="account-dropdown-name-container">
        <div class="account-dropdown-name">
          {{ (currentUser$ | async)?.first_name | titlecase }}
          {{ (currentUser$ | async)?.last_name | titlecase }}
        </div>
        <div class="account-dropdown-username">
          {{ (currentUser$ | async)?.username }}
        </div>
      </div>
    </div>
    <a
      *ngIf="showPlatformSwitcher$ | async"
      class="presence-switcher-button"
      [href]="presenceUrl"
      target="_blank"
    >
      <div class="presence-icon">
        <img src="assets/img/brand/presence-icon.svg" alt="Presence" />
      </div>
      <span class="presence-switcher-label">Switch to Presence</span>
    </a>
    <a
      *ngIf="canPurchase$ | async"
      class="account-dropdown-menu-item"
      routerLink="/purchase"
    >
      <span class="pl-2">Upgrade Plan</span>
    </a>
    <a
      *ngIf="billingAdminURL$ | async as url"
      class="account-dropdown-menu-item"
      target="_blank"
      [attr.href]="url"
    >
      <span class="pl-2">License Management</span>
    </a>
    <a
      *ngIf="showSecuritySettings$ | async"
      class="account-dropdown-menu-item"
      [attr.href]="securitySettingsUrl"
    >
      <span class="pl-2">Security settings</span>
    </a>
    <a
      class="account-dropdown-menu-item"
      target="_blank"
      href="https://www.presence.com/about/copyright-policy/"
    >
      <span class="pl-2">Copyright Policy</span>
    </a>
    <a
      class="account-dropdown-menu-item"
      target="_blank"
      href="https://presence.com/platform-terms-and-conditions/ "
    >
      <span class="pl-2">Terms of Use</span>
    </a>
    <a
      class="account-dropdown-menu-item with-bottom-border"
      target="_blank"
      href="https://www.presence.com/about/privacy-policy/"
    >
      <span class="pl-2">Privacy Policy</span>
    </a>
    <ng-container *ngIf="isSiriusEnabled; else legacySignOut">
      <a
        class="account-dropdown-menu-item"
        (click)="logout()"
        style="cursor: pointer"
      >
        <span class="pl-2">Sign Out</span>
      </a>
    </ng-container>
    <ng-template #legacySignOut>
      <a class="account-dropdown-menu-item" [href]="logoutHref">
        <span class="pl-2">Sign Out</span>
      </a>
    </ng-template>
  </div>
</mat-menu>
